
import { defineComponent, reactive, toRefs, useContext } from 'vue'
import { useLog } from '@/hooks'
import { getRandomFromArr } from '@/util/GlobalUtil'

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: true,
    },
    blogs: {
      type: Array,
      required: true,
      default: () => [],
    },
    pagingParams: {
      type: Object,
      rquired: true,
      default: () => ({
        pageSize: 10,
        currentPage: 1,
        total: 100,
      }),
    },
  },
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const { emit } = useContext()
    const state = reactive({})
    const randomTagType = () =>
      getRandomFromArr(['info', '', 'danger', 'warning', 'success'])

    const currentPageChange = (newCurrentPage: number) =>
      emit('currentPageChange', newCurrentPage)

    return {
      ...toRefs(state),
      randomTagType,
      currentPageChange,
    }
  },
})
